import { create } from 'zustand'

export type ToastTone = 'info' | 'success' | 'error'

// bottom — операционные тосты (результат действия); top — уведомления о
// событиях звонка (вход, лобби, чат), по центру сверху.
export type ToastPlacement = 'bottom' | 'top'

export interface ToastItem {
  id: string
  message: string
  tone: ToastTone
  placement: ToastPlacement
}

interface PushOptions {
  tone?: ToastTone
  ttlMs?: number
  placement?: ToastPlacement
}

interface ToastState {
  toasts: ToastItem[]
  push: (message: string, options?: PushOptions) => string
  dismiss: (id: string) => void
}

let counter = 0

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, { tone = 'info', ttlMs = 4000, placement = 'bottom' } = {}) => {
    counter += 1
    const id = String(counter)
    set((s) => ({ toasts: [...s.toasts, { id, message, tone, placement }] }))
    if (ttlMs > 0) {
      setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
      }, ttlMs)
    }
    return id
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

// Императивный фасад для вызова из обработчиков вне компонентов.
export const toast = {
  info: (message: string) => useToastStore.getState().push(message),
  success: (message: string) => useToastStore.getState().push(message, { tone: 'success' }),
  error: (message: string) => useToastStore.getState().push(message, { tone: 'error' }),
  // Событийное уведомление — по центру сверху.
  notify: (message: string) => useToastStore.getState().push(message, { placement: 'top' }),
}
